import React, { FC } from 'react';
import { PageTitle, PageLink } from '../../../../_mexablock/layout/core';
import { View } from './components/View';

const breadCrumbs: Array<PageLink> = [
  {
    title: 'Inventario',
    path: '/inventario/asignacion',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];

const AsignacionPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Asiganción</PageTitle>
      <View />
    </>
  );
};

export { AsignacionPage };
